// The QR code on our own vials encodes just the lot number: an MMDDYYYY date,
// a short alphanumeric suffix, and — on the lot itself, though not necessarily
// in the QR — a dash between them (e.g. 09282026-AB2). The handheld scanner
// types a QR read and an Rx label barcode identically (keyboard wedge), so the
// payload is the only way to tell them apart. An Rx label's barcode is its
// labelSId — a random nanoid (8 chars today; 10 or 12 on labels printed before
// Feb 2026) — which in practice never opens with 8 digits, so length is not
// relied on. Anything that is not a lot keeps going to the Rx lookup.
// Deliberately strict: other manufacturers' QR codes carry arbitrary data, not
// lot numbers, and must not be mistaken for one.
const VIAL_LOT_PATTERN = /^(\d{8})-?([A-Z0-9]+)$/i;

const isVialLotCode = (code) => VIAL_LOT_PATTERN.test(String(code ?? '').trim());

/** The lot number as inventory records it — dash restored, upper-cased — for
 *  lookups that match the exact string. Null when `code` is not a vial lot. */
export const canonicalVialLot = (code) => {
  const m = String(code ?? '')
    .trim()
    .match(VIAL_LOT_PATTERN);
  return m ? `${m[1]}-${m[2]}`.toUpperCase() : null;
};

/** Comparison key that ignores the dash (and any other punctuation), so a QR
 *  read with or without it matches the recorded lot. */
export const vialLotKey = (lot) =>
  String(lot ?? '')
    .replace(/[^A-Za-z0-9]/g, '')
    .toUpperCase();

export default isVialLotCode;
